import {
  GET_EXERCISE_ASSIGNMENT,
  CREATE_EXERCISE_ASSIGNMENT,
  UPDATE_EXERCISE_ASSIGNMENT,
  DELETE_EXERCISE_ASSIGNMENT,
} from "../actions/types";

const initialState = {
  assignmentList: [],
  assignmentSaveStatus: null,
  assignmentUpdateStatus: null,
  assignmentDeleteStatus: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_EXERCISE_ASSIGNMENT:
      return {
        ...state,
        assignmentList: action.payload.data,
      };

    case CREATE_EXERCISE_ASSIGNMENT:
      return {
        ...state,
        assignmentSaveStatus: action.payload.success,
      };

    case UPDATE_EXERCISE_ASSIGNMENT:
      return {
        ...state,
        assignmentUpdateStatus: action.payload.success,
      };

    case DELETE_EXERCISE_ASSIGNMENT:
      return {
        ...state,
        assignmentDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}